import { Box, IconButton } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import type { FC, ReactNode } from 'react';

export interface BannerRowPosition {
  index: number;
  isLast: boolean;
  /** Solo en la primera fila combinada, y solo con más de una fila. */
  collapseToggle: { collapsed: boolean; onToggle: () => void } | null;
}

export const BannerRow: FC<BannerRowPosition & { children: ReactNode }> = ({
  index,
  isLast,
  collapseToggle,
  children,
}) => (
  <Box
    display="flex"
    gap={2}
    alignItems="center"
    justifyContent="center"
    px={2}
    height={26}
    borderBottom={isLast ? 0 : 1}
    // darken the background color depending on the index
    bgcolor={`rgba(0, 0, 0, ${Math.min(index, 4) * 0.12})`}
  >
    {children}
    {collapseToggle && (
      <IconButton size="small" sx={{ color: 'black' }} onClick={collapseToggle.onToggle}>
        {collapseToggle.collapsed ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
    )}
  </Box>
);
